define('shared/initializer/form/adapters/AdyenUpdatePayment',[
    '$',
    './FramedForm',
    './mixins/AdyenUpdatable',
    './mixins/CheckoutFlowControllable',
    './mixins/OmnitureTriggerable',
    './mixins/AfterSubmitActionTriggerable',
    './mixins/Redirectable',
    './mixins/SubmitButtonEnableable',
    'shared/lib/ctor',
    '../newHouseAdapters/util/createAfterSubmitLifeCycle'
],
function (
    $,
    FramedForm,
    AdyenUpdatable,
    CheckoutFlowControllable,
    OmnitureTriggerable,
    AfterSubmitActionTriggerable,
    Redirectable,
    SubmitButtonEnableable,
    ctor,
    createAfterSubmitLifeCycle
) {
    'use strict';

    var METHOD_BEFORE_REDIRECT = 'doBeforeRedirect';

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply(me, arguments);

        me.lifeCycles.push(METHOD_BEFORE_REDIRECT);

        me.mixin(
            CheckoutFlowControllable,
            SubmitButtonEnableable,
            AdyenUpdatable,
            OmnitureTriggerable,
            createAfterSubmitLifeCycle(METHOD_BEFORE_REDIRECT, me),
            AfterSubmitActionTriggerable,
            Redirectable
        );

        me.disableButtonAfterSubmit = true;
    }).inherit(FramedForm);

    return Ctor;
});
